import { defaultPresetFor, getScenario } from "./scene/scenarios";
import type { ControllableCam, CropRect, Scenario } from "./scene/types";
import type { MultiviewBusSource } from "./multiview-layout";

export type { ControllableCam } from "./scene/types";

export interface CameraFraming {
  cam1: CropRect;
  cam2: CropRect;
  cam3: CropRect;
}

// Three PTZ cameras sit side-by-side at center-auditorium. CAM 1 is on
// the audience-left of the array, so its diagonal angle naturally favours
// the audience-right of the stage where the interviewees stand. CAM 2 is
// dead-centre and points head-on at the centred lectern. CAM 3 sits on
// the audience-right of the array and holds the wide / transition framing
// (and during introductions, the chairman's microphone on audience-left).
export function defaultCameraFramingFor(scenario: Scenario): CameraFraming {
  return {
    cam1: defaultPresetFor(scenario, "cam1").crop,
    cam2: defaultPresetFor(scenario, "cam2").crop,
    cam3: defaultPresetFor(scenario, "cam3").crop,
  };
}

// Back-compat: legacy callers that don't yet know about scenarios get the
// interview-segment defaults. Phase 3 lifts this out into context.
export const DEFAULT_CAMERA_FRAMING: CameraFraming = defaultCameraFramingFor(
  getScenario("interview-segment"),
);

function isControllableCam(source: MultiviewBusSource): source is ControllableCam {
  return source === "cam1" || source === "cam2" || source === "cam3";
}

export function cropForSource(
  source: MultiviewBusSource,
  cameraFraming?: Partial<CameraFraming>,
): CropRect | null {
  if (isControllableCam(source)) {
    return cameraFraming?.[source] ?? DEFAULT_CAMERA_FRAMING[source];
  }
  return null;
}
